import React, { useState, useEffect } from 'react';
import './Header.css';

const translations = {
  ar: {
    home: 'الرئيسية',
    features: 'المميزات',
    howItWorks: 'كيفية الحجز',
    about: 'من نحن',
    stats: 'الإحصائيات',
    download: 'التحميل'
  },
  en: {
    home: 'Home',
    features: 'Features',
    howItWorks: 'How It Works',
    about: 'About',
    stats: 'Statistics',
    download: 'Download'
  }
};

function Header({ language, toggleLanguage }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const t = translations[language];

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMenuOpen(false);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="container header-content">
        <div className="logo" onClick={() => scrollToSection('hero')}>
          <img src="/Match Up NEW.png" alt="MatchUp" />
          <span>MatchUp</span>
        </div>
        
        <nav className={`nav ${menuOpen ? 'open' : ''}`}>
          <button onClick={() => scrollToSection('hero')} className="nav-link">{t.home}</button>
          <button onClick={() => scrollToSection('features')} className="nav-link">{t.features}</button>
          <button onClick={() => scrollToSection('how-it-works')} className="nav-link">{t.howItWorks}</button>
          <button onClick={() => scrollToSection('about')} className="nav-link">{t.about}</button>
          <button onClick={() => scrollToSection('stats')} className="nav-link">{t.stats}</button>
          <button onClick={() => scrollToSection('download')} className="nav-link">{t.download}</button>
        </nav>

        <div className="header-actions">
          <button className="lang-btn" onClick={toggleLanguage}>
            {language === 'ar' ? 'EN' : 'ع'}
          </button>
          <button className="btn btn-primary" onClick={() => scrollToSection('download')}>
            {language === 'ar' ? 'حمّل الآن' : 'Download'}
          </button>
          <button className={`menu-btn ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
